import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import toastr from "toastr";

import "../styles/Campaign.css";
import CustomToolTip from "components/CustomToolTip";
import { CustomDropdown } from "components/CustomDropdown";

interface EditFixedPlanCampaignModalProps {
    showEditCampaignModal: boolean;
    closeModal: () => void;
    refreshCampaigns: () => void;
    policy_id: string;
    nextYearAccrualFrequency: string | null;
    setParentLoading: (loading: boolean) => void;
    onFailedSave: () => void;
}

const EditFixedPlanCampaignModal: React.FC<EditFixedPlanCampaignModalProps> = ({
    showEditCampaignModal,
    closeModal,
    refreshCampaigns,
    policy_id,
    nextYearAccrualFrequency,
    setParentLoading,
    onFailedSave
}) => {
    const [frequency, setFrequency] = useState<string>("None");

    useEffect(() => {
        setFrequency(nextYearAccrualFrequency ?? "None");
    }, [nextYearAccrualFrequency]);

    const handleSave = async () => {
        const body = {
            PolicyId: policy_id,
            NextYearScheduledCreditsFrequency:
                frequency === "None" ? null : frequency
        };

        setParentLoading(true);
        closeModal();

        try {
            const response = await axios.put(
                "/api/FixedCampaign/editpolicyfixedcampaign",
                body
            );

            if (response.data?.success === true) {
                toastr.success("Campaign updated successfully");
                refreshCampaigns();
            } else {
                toastr.error(response.data?.message || "Failed to update campaign");
                onFailedSave();
            }
        } catch {
            toastr.error("An error occurred while updating the campaign");
            onFailedSave();
        } finally {
            setParentLoading(false);
        }
    };

    return (
        <Modal
            className="react-modal edit-campaign-modal"
            show={showEditCampaignModal}
            onHide={closeModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Edit New Year Plan Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    className="RT-TextBox"
                    style={{
                        backgroundColor: "white",
                        padding: "15px 20px",
                        marginTop: "20px",
                        borderRadius: "8px"
                    }}
                >
                    <label className="RT-Label" style={{ paddingLeft: 10 }}>
                        Scheduled Credits Frequency
                        <CustomToolTip
                            header="Scheduled Credits Frequency"
                            bodyContent="Confirm the Frequency for next year's Scheduled Credits. Only Ops users may make this adjustment."
                        />
                    </label>

                    <CustomDropdown
                        options={["None", "Monthly", "Quarterly", "Semiannually"]}
                        selectedOption={frequency}
                        setSelectedOption={setFrequency}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditFixedPlanCampaignModal;
